import { AxiosError, AxiosResponse } from 'axios';

import { ERROR } from '../enums';

interface IError {
  error: ERROR;
  message: string;
  path: string;
  status: number;
  timestamp: string;
}

export interface IErrorResponse extends AxiosError {
  response: AxiosResponse<IError>;
}

export interface IFormErrorResponse extends AxiosError {
  response: AxiosResponse<IError[]>;
}

export const PAGINATION_ORDER = ['asc', 'desc'] as const;
export type PaginationOrder = (typeof PAGINATION_ORDER)[number];

export interface IPaginationParams {
  page?: number;
  size?: number;
  sort?: {
    name: string;
    order?: PaginationOrder;
  };
  name?: string;
  hideReadyForDeletion?: boolean;
}

export interface IPagination<ContentType> {
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
  size: number;
  content: ContentType[];
  number: number;
  sort: {
    empty: boolean;
    unsorted: boolean;
    sorted: boolean;
  };
  pageable: {
    offset: number;
    sort: {
      empty: boolean;
      unsorted: boolean;
      sorted: boolean;
    };
    paged: boolean;
    unpaged: boolean;
    pageNumber: number;
    pageSize: number;
  };
  numberOfElements: number;
  empty: boolean;
}
